import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import moment from 'moment-timezone';

import {
  usePage,
  useTealium,
  useAdGlare,
  useUnmountResetPage,
  useNotFound,
  useDebounceLoading,
  useDelayJsLoadiing,
  useURLChangeCallback,
} from '../../utils/hookHelper';

import { sanitizedHTML, forceToArray, momentUTCDate, isSSOLoggedIn } from '../../utils/Helper';

import HelmetMeta from '../../components/HelmetMeta';
import HelmetTitle from '../../components/HelmetTitle';
import HelmetStyle from '../../components/HelmetStyle';
import HelmetScript from '../../components/HelmetScript';
import HelmetHead from '../../components/HelmetHead';
import Loader from '../../components/Loader';
import UnderConstruction from '../../components/UnderConstruction';
import PageIntro from '../../components/PageIntro';
import NoMatch from '../NoMatch';
import MemberOnly from '../../components/MemberOnly';

import PressReleaseSlider from '../../widgets/PressReleaseSlider';
import config from '../../config';

import './PromotionPage.scss';

const PromotionPage = (props) => {
  const {
    match = {},
    i18n,
    staticPage,
    allowCookies,
    enableTealium,
    enableAdGlare,
    siteConfig,
  } = props;
  const debouncePageLoading = useDebounceLoading(staticPage);
  const jsLoading = useDelayJsLoadiing(staticPage);
  const notFound = useNotFound(staticPage);

  usePage(match.params.pageName, config.pageType.promotionPage);
  useAdGlare(i18n.locale, siteConfig, staticPage, enableAdGlare.status);
  useUnmountResetPage();

  const { translations = {}, locale } = i18n || {};
  const { press = {} } = translations[locale] || {};
  const { data = {} } = staticPage || {};
  const content = ((data || {}).content || {}).content || {};
  const dataContent = content[locale] || {};
  const { under_construction = false, contentPublishDate = '' } = content;

  moment.locale(config.momentLangMap[locale]);

  // content
  const headline = dataContent.headline || '';
  // const contentPublishDate = dataContent.content_publish_date || '';
  const formattedPublishDate =
    contentPublishDate !== '' && moment(momentUTCDate(contentPublishDate)).format('LL');
  const description = dataContent.description || '';
  const contentBody = dataContent.content_body || '';

  const sliderObj = dataContent.slider || [];
  const slider = [];

  // Make sure no empty slider
  if (sliderObj.length > 0) {
    let sCount;
    for (sCount = 0; sCount < sliderObj.length; sCount++) {
      const sliderObjItem = sliderObj[sCount];
      sliderObjItem.image !== '' && slider.push(sliderObjItem);
    }
  }

  // HelmetMeta
  const { metadata = {} } = data || {};
  const publishDate = metadata['TeamSite/LiveSite/PublishDate'];
  const seo = dataContent.seo || {};
  const contentBodyCSS = dataContent['content_body.css'] || '';
  const { css_style_block = '', js_script_block = '', extra_head = '' } = content;

  const title = seo.seo_title;
  const [domTitle, setDomTitle] = useState('');
  const [isScriptReady, setIsScriptReady] = useState(false);

  useTealium(
    i18n.locale,
    siteConfig,
    staticPage,
    allowCookies.status,
    enableTealium.status,
    domTitle,
  );

  useURLChangeCallback(locale, data, null, [], isScriptReady);

  const helmetTitleCallBack = (newState) => {
    setDomTitle(newState.title);
  };

  const helmetScriptCallBack = (isReady) => {
    setIsScriptReady(isReady);
  };

  const headlineEle = headline && <PageIntro headline={headline} secondTitle={press.headline} />;

  const headlineDesc = description && (
    <div dangerouslySetInnerHTML={{ __html: sanitizedHTML(description) }} />
  );

  const mainBody = contentBody && (
    <div dangerouslySetInnerHTML={{ __html: sanitizedHTML(contentBody) }} />
  );

  const mainContent = (
    <div className="press-detail-content">
      <div className="press-detail-content-title">{headline}</div>
      {headlineDesc}
      <div className="press-detail-content-date">{formattedPublishDate}</div>
      <div className="press-detail-content-body">{mainBody}</div>
    </div>
  );

  const slidersComponent = slider && forceToArray(slider) && forceToArray(slider).length > 0 && (
    <PressReleaseSlider lists={forceToArray(slider)} locale={locale} />
  );

  // make sure SSO is ready
  const memberOnlyInd = metadata.memberOnly === 'true';

  const contentEle =
    memberOnlyInd && !isSSOLoggedIn() ? (
      <MemberOnly />
    ) : (
      <>
        <Container>
          {under_construction && <UnderConstruction />}
          {!under_construction && mainContent}
        </Container>
        {!under_construction && (
          <HelmetScript
            helmetScriptCallBack={helmetScriptCallBack}
            extraHead={extra_head}
            jsScript={js_script_block}
          />
        )}
      </>
    );

  const pageEle = (
    <div>
      {notFound ? (
        <NoMatch />
      ) : (
        <div>
          {headlineEle}
          {!under_construction && slidersComponent}
          {contentEle}
        </div>
      )}
    </div>
  );

  return (
    <>
      {debouncePageLoading || jsLoading ? <Loader /> : pageEle}
      {!debouncePageLoading && <HelmetHead extraHead={extra_head} />}
      {!debouncePageLoading && <HelmetStyle stylesheet={css_style_block} />}
      {!debouncePageLoading && <HelmetStyle stylesheet={contentBodyCSS} name="contentBodyCSS" />}
      {!debouncePageLoading && <HelmetTitle title={title} cb={helmetTitleCallBack} />}
      {!debouncePageLoading && <HelmetMeta seo={seo} publishDate={publishDate} />}
    </>
  );
};

const mapStateToProps = (state) => ({
  i18n: state.i18n,
  staticPage: state.generalPage,
  allowCookies: state.allowCookies,
  enableTealium: state.enableTealium,
  enableAdGlare: state.enableAdGlare,
  siteConfig: state.siteConfig,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(PromotionPage);

export { PromotionPage as PromotionPageComponent }; // <- For component Unit Test
export default connectStore;
